/** Build-time POA UI surfaces (category state emails, Gmail integrations). */
export const isPoaUiEnabled = (): boolean => process.env.REACT_APP_ENABLE_POA_UI === 'true';

/** Staging/local debug pages — never registered in production builds. */
export const isNonProductionUi = (): boolean => {
    const appEnv = (process.env.REACT_APP_ENVIRONMENT || '').toLowerCase();
    if (appEnv) {
        return appEnv !== 'production' && appEnv !== 'prod';
    }
    return process.env.NODE_ENV !== 'production';
};
